<ng-container *hasPermission="['CAMERA_READ','CAMERA_ALL']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Dettaglio camera - <b>{{detail_title}}</b></h2>
        </div>
        <form name="organizationForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">
                <div class="col-md-6 ">
                    <label for="name" class="form-label">Name</label>
                    <input type="text" class="form-control" id="name" name="name" ngModel #name="ngModel"
                        [(ngModel)]="camera.name" required />

                </div>
                <div class="col-md-6">
                    <label for="name" class="form-label">Tipologia</label>
                    <select class="form-select" aria-label="Tipo" id="type" name="type" [(ngModel)]="camera.type"
                        required>
                        <option selected value=""></option>
                        <option *ngFor="let cameraType of cameraTypes" [value]="cameraType.id">
                            {{cameraType.description}}</option>
                    </select>
                </div>

            </div>
            <div class="row">
                <div class="col-md-6">
                    <label for="name" class="form-label">Modalità</label>
                    <select class="form-select" aria-label="Tipo" id="detectionMode" name="detectionMode"
                        [(ngModel)]="camera.detectionMode" required>
                        <option selected value=""></option>
                        <option *ngFor="let cameraDetectionMode of cameraDetectionModes"
                            [value]="cameraDetectionMode.id">
                            {{cameraDetectionMode.description}}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label for="identifier" class="form-label">Identificativo</label>
                    <input type="text" class="form-control" id="name" name="identifier" ngModel #identifier="ngModel"
                        [(ngModel)]="camera.identifier" required />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label for="name" class="form-label">Modalità integrazione</label>
                    <select class="form-select" aria-label="Tipo" id="manageAuth" name="manageAuth"
                        [(ngModel)]="camera.manageConfigsType" required>
                        <option selected value="NONE">Nessuna</option>
                        <option selected value="HIKVISION">Hikvision</option>
                        <option selected value="VIGILATE">Vigilate</option>
                    </select>
                </div>
            </div>
            @if (camera.manageConfigsType=='HIKVISION' ) {
            <app-hikvision-configs [authConfig]="manageConfiguration.auth!"></app-hikvision-configs>
            }
            @if (camera.manageConfigsType=='VIGILATE' ) {
            <app-vigilate-configs [authConfig]="manageConfiguration.auth!"></app-vigilate-configs>
            }

            <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>

                <ng-template [hasPermission]="['CAMERA_DELETE', 'CAMERA_ALL']">
                    @if (camera.id !== undefined) {
                    <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                        Elimina
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['CAMERA_UPDATE', 'CAMERA_ALL']">
                    @if (camera.id !== undefined) {
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['CAMERA_CREATE', 'CAMERA_ALL']">
                    @if (camera.id === undefined) {
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }

                </ng-template>

            </div>
        </form>
        <app-confirm-alert [confirmationMessage]="'Eliminazione camera - '+confirmationMessage"
            [showConfirmationModal]="showConfirmationModal" (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
        </app-confirm-alert>
    </div>

</ng-container>